import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class CartApiService {

    constructor(private http: ApiHttpClient) { }

    public get(purchaseSetId: camps.Guid): Observable<api.OperationResultValue<camps.OfficeCartInfo>> {
        return this.http.get<api.OperationResultValue<camps.OfficeCartInfo>>(`cart/${purchaseSetId}`, true);
    }

    public getSummary(purchaseSetId: camps.Guid): Observable<api.OperationResultValue<camps.OfficeCartSummaryInfo>> {
        return this.http.get<api.OperationResultValue<camps.OfficeCartSummaryInfo>>(`cart/summary/${purchaseSetId}`, true);
    }

    public addSession(request: camps.OfficeCartAddSessionRequest): Observable<api.OperationResultValue<camps.OfficeCartInfo>> {
        return this.http.post<api.OperationResultValue<camps.OfficeCartInfo>>(`cart/addSession`, request, true);
    }

    public removeSession(request: camps.OfficeCartRemoveSessionRequest): Observable<api.OperationResultValue<camps.OfficeCartInfo>> {
        return this.http.post<api.OperationResultValue<camps.OfficeCartInfo>>(`cart/removeSession`, request, true);
    }

    public removeOption(request: camps.OfficeCartRemoveOptionRequest): Observable<api.OperationResultValue<camps.OfficeCartInfo>> {
        return this.http.post<api.OperationResultValue<camps.OfficeCartInfo>>(`cart/removeOption`, request, true);
    }
    public addOption(request: camps.OfficeCartAddOptionRequest): Observable<api.OperationResultValue<camps.OfficeCartInfo>> {
        return this.http.post<api.OperationResultValue<camps.OfficeCartInfo>>(`cart/addOption`, request, true);
    }

    public setRefundReason(request: camps.PartialRefundSetReasonRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResult>(`cart/setReason`, request, true);
    }
}
